import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

const HEADERS = [
  'Offer',
  'Type',
  'Price level',
  'Base price',
  'Seats',
  'Offer price',
  'Facility fee',
  'Service fee',
  'Processing fee (est.)',
  'Sales tax',
  'Charge back prot.',
  'Total to buyer',
  'Your payout',
  'Max payout',
  'On-sale start',
  'On-sale end',
  'Access code',
  'Ticket limit',
  'Hidden',
  'Inventory set',
]

const CURRENCY = '"$"#,##0.00'
const DATE_TIME = 'm/d/yyyy h:mm AM/PM'

const moneyColumns = [4, 6, 7, 8, 9, 10, 11, 12, 13, 14]
const boldMoneyColumns = [12, 13]

function offerCells(offer, level) {
  return [
    offer.name,
    offer.type,
    level?.name || '',
    level ? level.basePrice : null,
    level ? level.seats : null,
    level ? level.offerPrice : null,
    level ? level.facilityFee : null,
    level ? level.serviceFee : null,
    level ? level.processingFee : null,
    level ? level.salesTax : null,
    level ? level.chargeBackProtection : null,
    level ? level.totalToBuyer : null,
    level ? level.payout : null,
    level ? level.maxPayout : null,
    offer.onSaleStart,
    offer.onSaleEnd,
    offer.accessCodeExcel || '',
    offer.ticketLimitLabel || '',
    offer.hiddenLabel,
    offer.inventory.label || '',
  ]
}

export async function createOfferWorkbook(report) {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'blocktickets'
  const sheet = workbook.addWorksheet('Offer breakdown', {
    views: [{ state: 'frozen', ySplit: 1 }],
  })

  sheet.addRow(HEADERS)
  const header = sheet.getRow(1)
  header.font = { bold: true, name: 'Calibri', size: 11 }
  header.alignment = { vertical: 'middle', wrapText: true }
  header.height = 30

  const levels = report.offers.flatMap((offer) =>
    offer.priceLevels.length
      ? offer.priceLevels.map((level) => offerCells(offer, level))
      : [offerCells(offer, null)]
  )
  levels.forEach((values) => sheet.addRow(values))

  sheet.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: HEADERS.length },
  }

  sheet.columns = [
    { width: 24 },
    { width: 14 },
    { width: 22 },
    { width: 14 },
    { width: 10 },
    { width: 14 },
    { width: 14 },
    { width: 14 },
    { width: 22 },
    { width: 12 },
    { width: 18 },
    { width: 16 },
    { width: 14 },
    { width: 14 },
    { width: 22 },
    { width: 22 },
    { width: 22 },
    { width: 28 },
    { width: 12 },
    { width: 28 },
  ]

  for (let rowIndex = 2; rowIndex <= sheet.rowCount; rowIndex += 1) {
    const row = sheet.getRow(rowIndex)
    moneyColumns.forEach((column) => {
      const cell = row.getCell(column)
      if (cell.value === null || cell.value === '') return
      cell.numFmt = CURRENCY
      if (boldMoneyColumns.includes(column)) cell.font = { bold: true }
    })
    ;[15, 16].forEach((column) => {
      const cell = row.getCell(column)
      if (cell.value instanceof Date) cell.numFmt = DATE_TIME
    })
    const seats = row.getCell(5)
    if (typeof seats.value === 'number') seats.numFmt = '#,##0'
  }

  return workbook
}

export async function downloadOfferExcel(report) {
  const workbook = await createOfferWorkbook(report)
  const buffer = await workbook.xlsx.writeBuffer()
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    `${report.fileBaseName}.xlsx`
  )
}
